/* eslint-disable no-unsafe-finally */
/* eslint-disable react/function-component-definition */
/* eslint-disable no-underscore-dangle */
import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  List,
  ListItem,
  CircularProgress,
  Container,
} from "@mui/material";
import NoteDlg from "../../components/NoteDlg";
import { getItem } from "../../utils/nauth";
import dayjs from "dayjs";
import { postHistory } from "../../api/History";
import { Message } from "../../components";

type NotesContainerProps = {
  templateId: string;
  isOperator: boolean;
  notes: any;
  historyFunc: (id: string) => void;
};

const _initInput = {
  note: "",
};

export default function NotesContainer({
  templateId,
  isOperator,
  notes,
  historyFunc,
}: NotesContainerProps) {
  const [isLoading, setLoading] = useState(true);
  const [editNote, setEditNote] = useState(false);
  const [input, setInput] = useState({ ..._initInput });
  const [openDlg, setOpenDlg] = useState(false);
  const [roleDlg, setRoleOpenDlg] = useState(false);
  const userEmail = getItem("email") || getItem("name") || "No name";

  const handleClose = () => {
    setRoleOpenDlg(false);
    setOpenDlg(false);
  };
  const handleDlgBtnYes = () => {
    if (!isOperator) {
      setRoleOpenDlg(true);
      return;
    }
    if (input.note.length < 1) {
      alert("Please enter the contents of the note.");
      setOpenDlg(false);

      return;
    }
    const data = {
      comment: input.note ? input.note.trim() : input.note,
    };
    setLoading(true);
    try {
      postHistory(userEmail, data, templateId)
        .then(() => {
          setTimeout(() => {
            historyFunc(templateId);
            setInput(_initInput);
          }, 150);
        })
        .catch((err) => {
          console.log("NoteHistoryErr", err);
        })
        .finally(() => {
          setOpenDlg(false);
        });
    } catch (err) {
      console.log("Note Err", err);
    } finally {
      setLoading(false);
      setOpenDlg(false);
    }
  };

  const handleInputNote = (e: any) => {
    e.preventDefault();
    setInput({
      ...input,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    if (input && input.note.length > 0) setEditNote(true);
    else setEditNote(false);
    setLoading(false);
  }, [input]);

  if (isLoading) {
    return (
      <Container
        sx={{
          mt: "100px",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <CircularProgress />
      </Container>
    );
  }

  const noteInputBox = () => {
    return (
      <Box sx={{ mb: "-30px" }}>
        <Box sx={{ mt: 1, mb: 1, display: "flex", alignItems: "stretch" }}>
          <TextField
            name={"note"}
            sx={{ width: "100%", alignSelf: "auto" }}
            multiline
            maxRows={2}
            placeholder="Write Notes"
            inputProps={{ style: { height: 45 } }}
            value={input.note}
            onChange={handleInputNote}
          />
        </Box>
        <Box sx={{ display: "flex", flexDirection: "row-reverse" }}>
          <Button
            variant="text"
            onClick={() => {
              setOpenDlg(true);
            }}
          >
            Add Notes
          </Button>
          <NoteDlg
            open={openDlg}
            contentText={"Do you want to save the changes?"}
            handleNo={() => {
              setOpenDlg(false);
            }}
            handleYes={handleDlgBtnYes}
          />
          <Button
            variant="text"
            onClick={() => {
              setInput(_initInput);
            }}
          >
            Cancel
          </Button>
        </Box>
      </Box>
    );
  };

  return (
    <Box
      sx={{
        m: "10px",
        paddingTop: "10px",
      }}
    >
      <Box width={"30%"}>
        <Typography fontWeight={500}>Notes</Typography>
      </Box>
      {notes && notes.totalCount > 0 ? (
        <List
          sx={{
            width: "100%",
            maxHeight: 200,
            overflow: "auto",
            bgcolor: "rgba(98, 91, 113, 0.08)",
          }}
        >
          {notes.history.map((note: any, idx: any) => (
            <ListItem key={idx} alignItems="flex-start">
              <Typography minWidth={"200px"}>{`${dayjs(note.createdAt).format(
                "YYYY-MM-DD HH:mm"
              )}`}</Typography>
              <Typography minWidth={"300px"}>{note.user}</Typography>
              <Typography
                sx={{
                  wordWrap: "break-word",
                  overflow: "hidden",
                }}
              >
                {note.details.comment
                  ? note.details.comment.trim()
                  : note.details.comment}
              </Typography>
            </ListItem>
          ))}
        </List>
      ) : null}
      <Message open={roleDlg} handleClose={handleClose} />
      {noteInputBox()}
    </Box>
  );
}
